import localStorage from '@bingads-webui-component-legacy/storage/localStorage';

export function on(observable, key) {
  const ret = localStorage.get(key);

  if (ret !== null) {
    observable(ret);
  }

  observable.subscribe((value) => {
    localStorage.set(key, value);
  });
}
